import { cn } from "@/lib/utils";

interface CreationFlowStickyActionBarProps {
  children?: React.ReactNode;
  start?: React.ReactNode;
  center?: React.ReactNode;
  end?: React.ReactNode;
  className?: string;
}

export function CreationFlowStickyActionBar(
  props: CreationFlowStickyActionBarProps,
) {
  const { children, start, center, end, className } = props;
  const isToolbar = start != null || center != null || end != null;

  return (
    <div className="sticky bottom-0 left-0 right-0 z-10 pointer-events-none">
      <div
        className="h-3"
        style={{
          background:
            "linear-gradient(180deg, transparent 0%, hsl(var(--background)) 100%)",
        }}
      />
      <div
        className={cn(
          "bg-background px-4 pt-2 pb-2 pointer-events-auto",
          className,
        )}
      >
        {isToolbar ? (
          <div className="relative flex w-full items-center">
            <div className="flex min-w-0 flex-1 justify-start">{start}</div>
            {center ? (
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                {center}
              </div>
            ) : null}
            <div className="flex min-w-0 flex-1 justify-end">{end}</div>
          </div>
        ) : (
          <div className="flex justify-center gap-2">{children}</div>
        )}
      </div>
    </div>
  );
}
